import React from 'react';
import { motion } from 'framer-motion';
import { Award, ShieldCheck, MapPin } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: Award,
    text: '4+ Años de Experiencia'
  }, {
    icon: ShieldCheck,
    text: 'Certificación AMPI/SEP en Proceso'
  }, {
    icon: MapPin,
    text: 'Expertos en Riviera Maya'
  }];
  return <section className="w-full bg-white border-y border-gray-100 py-8 relative z-30" data-id="element-236">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-237">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4" data-id="element-238">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex items-center gap-4 text-charcoal/80 group" data-id="element-239">
              <div className="w-12 h-12 rounded-full bg-pearl flex items-center justify-center group-hover:bg-gold/10 transition-colors duration-300" data-id="element-240">
                <item.icon className="text-gold" size={24} strokeWidth={1.5} data-id="element-241" />
              </div>
              <span className="font-medium text-sm md:text-base tracking-wide" data-id="element-242">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}